import { sample, sampleSize } from 'lodash';

interface ItemBase {
  id: string;
  name: string;
}

interface Item extends ItemBase {
  parentId?: string | null;
  breadcrumbs?: ItemBase[];
}

export function nestifyItems<T extends Item>(
  items: T[],
  {
    depth,
    setDepthOnItem,
    forceEmptyParentInEachLevel,
  }: {
    forceEmptyParentInEachLevel?: boolean;
    depth: number;
    setDepthOnItem?: (
      item: T,
      params: { depth: number; parent: T | null | undefined },
    ) => void;
  },
) {
  const total = items.length;
  const sampled = [] as T[];
  const sampledByLevel = new Map<number, T[]>();

  for (let i = 0; i < depth; i++) {
    const sectionSize = Math.floor(
      i === depth - 1
        ? total - sampled.length
        : total / Math.pow(2, depth - i + 1),
    );

    const section = sampleSize(
      items.filter((value) => !sampled.includes(value)),
      sectionSize,
    );
    sampled.push(...section);
    sampledByLevel.set(i, section);
    section.forEach((item) => {
      const parent =
        i === 0
          ? null
          : sample(
              sampledByLevel
                .get(i - 1)
                ?.slice(forceEmptyParentInEachLevel ? 1 : 0),
            );
      setDepthOnItem?.(item, {
        depth: i,
        parent,
      });
      item.parentId = parent?.id ?? null;
      if (parent) {
        item.breadcrumbs = [
          ...(parent.breadcrumbs ?? []),
          { id: parent.id, name: parent.name },
        ];
      }
    });
  }
}
